import { PageResponse } from '@omnia/ui/src/lib'
import type { CurzonGridRow } from '@/features/grid/grid.types'

export class NotFoundPageResponse extends PageResponse {
    public grid: CurzonGridRow[]
}
